import { apiClient } from './axios';
import { ExceptionGroupItem, ExceptionLogItem, ExceptionLogDetail } from '../types/exception';
import { PaginationData } from '../models/paginationData';

export const exceptionApi = {
    getGroups: (page: number, size: number, isResolved?: boolean) =>
        apiClient.get<PaginationData<ExceptionGroupItem>>('/admin/exceptions/groups', {
            page,
            size,
            ...(isResolved !== undefined ? { isResolved } : {}),
        }),

    resolveGroup: (groupId: number, isResolved: boolean) =>
        apiClient.patchNoData(`/admin/exceptions/groups/${groupId}/resolve`, { isResolved }),

    getGroupLogs: (groupId: number, page: number, size: number) =>
        apiClient.get<PaginationData<ExceptionLogItem>>(`/admin/exceptions/groups/${groupId}/logs`, { page, size }),

    getLog: (logId: number) =>
        apiClient.get<ExceptionLogDetail>(`/admin/exceptions/logs/${logId}`),
};
